/** 将编辑器滚动到文末，并尽量让光标区域可见（追加文末等场景） */
export function scrollEditorToEnd(root: HTMLElement | null) {
  if (!root) return

  const run = () => {
    const scrollers = [
      root.querySelector('.vditor-content'),
      root.querySelector('.vditor-ir'),
      root.querySelector('.w-e-scroll'),
      root.querySelector('.html-doc-editor-body'),
      root.closest('.html-doc-editor')?.querySelector('.html-doc-editor-body'),
    ].filter(Boolean) as HTMLElement[]

    for (const el of scrollers) {
      if (el.scrollHeight > el.clientHeight) {
        el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
      }
    }

    const sel = window.getSelection()
    if (!sel?.rangeCount) return
    const range = sel.getRangeAt(0)
    const node = range.startContainer
    const target = node.nodeType === Node.TEXT_NODE ? node.parentElement : (node as Element)
    target?.scrollIntoView({ block: 'end', behavior: 'smooth' })
  }

  requestAnimationFrame(() => requestAnimationFrame(run))
}
